export default "__VITE_ASSET__BjwjByxM__"